var React = require('react');

class Buttons extends React.Component {


  render () {

    return (
      <div className="walkthrough-buttons">

        <a href="#"
           onClick={this.props.back}
           className="cpt-button pull-left"
           style={{display: (!this.props.backText) ? 'none' : null}}>
          {this.props.backText}
        </a>

        <a href="#"
           onClick={this.props.continue}
           className="cpt-button pull-right style-primary"
           style={{display: (!this.props.continueText) ? 'none' : null}}>
          {this.props.continueText}
        </a>

      </div>
    )
  }
}

module.exports = Buttons;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/buttons.jsx